<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';

defineProps({
  code: { type: String, default: '' },
  error: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  success: { type: Boolean, default: false },
});

const emit = defineEmits(['search', 'update:code']);
const { t } = useI18n();

const submit = event => {
  event.preventDefault();
  emit('search');
};

const input = event => {
  emit('update:code', event.target.value);
};
</script>

<template>
  <LaisCard
    :title="t('SALES.CREATE.LOOKUP_TITLE')"
    prefix-icon="i-lucide-search"
    class="w-full"
  >
    <form class="grid gap-4" @submit="submit">
      <div class="grid gap-2">
        <label
          for="sales-property-code"
          class="text-sm font-semibold text-lais-text"
        >
          {{ t('SALES.CREATE.CODE_LABEL') }}
        </label>
        <input
          id="sales-property-code"
          :value="code"
          type="text"
          autocomplete="off"
          :placeholder="t('SALES.CREATE.CODE_PLACEHOLDER')"
          class="h-11 rounded-lais-sm border bg-white px-3 text-sm text-lais-text outline-none transition placeholder:text-lais-text-muted focus:border-lais-primary"
          :class="
            error
              ? 'border-red-400'
              : success
                ? 'border-emerald-500'
                : 'border-lais-border'
          "
          @input="input"
        />
        <span
          v-if="loading"
          class="i-lucide-loader-circle size-4 animate-spin text-lais-primary"
          aria-hidden="true"
        />
        <p v-if="error" class="text-xs text-red-600" role="alert">
          {{ error }}
        </p>
      </div>
    </form>
  </LaisCard>
</template>
